import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from "@angular/router";
import { CONTACTS_CRM_MODULE } from "@app/shared/utils/crm-modules";
import { SEARCH_PROFILE_ALERT_CREATE } from "@app/shared/utils/tab-types";
import { CrmModule } from "@app/sidebar/models/crm-module";
import { SidebarService } from "@app/sidebar/sidebar.service";

@Injectable()
export class SearchProfileAlertCreateGuard implements CanActivate {
  crmModules = [CONTACTS_CRM_MODULE];

  constructor(private sidebarService: SidebarService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const crmModule = this.crmModules
      .map((module) => new CrmModule(module))
      .find((module) => module.isModuleActive(state.url));

    return this.sidebarService.canActivateTab(
      route,
      state.url,
      crmModule,
      SEARCH_PROFILE_ALERT_CREATE
    );
  }
}
